import Animations from '../standalone/animations';
window.Animations = new Animations();

import PublishOrPreviewCheck from '../standalone/preview-check';
window.PublishOrPreviewCheck = new PublishOrPreviewCheck();

import LoadingScreen from './views/loadingscreen';
import GrplHeader from './blocks/header';
import GrplMenu from './blocks/menu';

import router from './helpers/router'
import store from './helpers/store'

window.templatePath = '/wp-content/themes/grapple/dist/';
window.Event = new Vue();

if( $('#root').length > 0 ){
    window.myPage = new Vue({
        components: {
            LoadingScreen
        },
        router,
        store
    }).$mount('#root');
}

if( $('#headerApp').length > 0 )
{
    window.myHeader = new Vue({
        el: '#headerApp',
        components: {
            GrplHeader,
            GrplMenu
        },
        router,
        store
    });
}

